import { discoverCategories } from '../../../mocks/discover';

interface DiscoverFiltersProps {
  searchQuery: string;
  onSearchChange: (val: string) => void;
  activeCategory: string;
  onCategoryChange: (cat: string) => void;
  pricingFilter: string;
  onPricingChange: (val: string) => void;
  sortBy: string;
  onSortChange: (val: string) => void;
}

export function DiscoverFilters({
  searchQuery,
  onSearchChange,
  activeCategory,
  onCategoryChange,
  pricingFilter,
  onPricingChange,
  sortBy,
  onSortChange
}: DiscoverFiltersProps) {
  return (
    <div className="mb-6 space-y-4">
      {/* Search bar */}
      <div className="relative">
        <i className="ri-search-line absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 text-lg"></i>
        <input
          type="text"
          placeholder="Search AGI products, tools, websites..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          className="w-full pl-12 pr-4 py-3.5 bg-white border border-gray-200 text-sm text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-900 shadow-sm"
        />
      </div>

      {/* Category pills + filters row */}
      <div className="flex items-center justify-between gap-4">
        <div className="flex items-center gap-2 overflow-x-auto pb-1 flex-1 scrollbar-hide">
          {discoverCategories.map(cat => (
            <button
              key={cat}
              onClick={() => onCategoryChange(cat)}
              className={`px-3.5 py-1.5 text-xs font-medium whitespace-nowrap transition-colors cursor-pointer ${
                activeCategory === cat
                  ? 'bg-[#0A0A0A] text-white'
                  : 'bg-white border border-gray-200 text-gray-600 hover:bg-gray-50'
              }`}
            >
              {cat}
            </button>
          ))}
        </div>

        <div className="flex items-center gap-2 flex-shrink-0">
          <select
            value={pricingFilter}
            onChange={(e) => onPricingChange(e.target.value)}
            className="px-3 py-1.5 border border-gray-200 bg-white text-xs text-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-900 cursor-pointer"
          >
            <option value="all">All Pricing</option>
            <option value="Free">Free</option>
            <option value="Freemium">Freemium</option>
            <option value="Paid">Paid</option>
          </select>
          <select
            value={sortBy}
            onChange={(e) => onSortChange(e.target.value)}
            className="px-3 py-1.5 border border-gray-200 bg-white text-xs text-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-900 cursor-pointer"
          >
            <option value="newest">Newest First</option>
            <option value="trending">Trending</option>
            <option value="rating">Top Rated</option>
            <option value="users">Most Users</option>
          </select>
        </div>
      </div>
    </div>
  );
}
